import { VerticalContainer } from '@american-autonomy/ag-ui';

import ErrorButton from 'components/buttons/ErrorButton';
import PrimaryButton from 'components/buttons/PrimaryButton';
import ModalBodyContainer from 'components/containers/ModalBodyContainer';
import ModalFooterContainer from 'components/containers/ModalFooterContainer';
import ModalHeaderContainer from 'components/containers/ModalHeaderContainer';
import DrawerTitleText from 'components/text/DrawerTitleText';

import useFormDiscardConfirmation from 'hooks/useFormDiscardConfirmation';

import useData from './hooks/useData';
import useTranslation from './hooks/useTranslation';

import LogServiceFormFields from './components/LogServiceFormFields';
import { CANCEL_TEST_ID, SAVE_TEST_ID, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const LogServiceForm: FunctionComponent<Props> = ({
    assetId,
    className = '',
    isSaving,
    onCancelClose,
    onClose,
    onRequestClose,
    onSubmit,
    requestingClose,
    testId = TEST_ID
}) => {
    const { CANCEL, LOG_SERVICE, SAVE } = useTranslation();

    const {
        form,
        handleSubmit,
        isCalibration,
        isPartRequired,
        isPartVisible,
        isSaveDisabled,
        isUnitVisible,
        unitPartType
    } = useData({ assetId, isSaving, onSubmit });

    const {
        formState: { isDirty }
    } = form;

    const { confirmationPanel, showConfirmation } = useFormDiscardConfirmation({
        isDirty,
        onCancelClose,
        onClose,
        requestingClose
    });

    return (
        <VerticalContainer className={`${className} ${styles.logServiceForm}`} testId={testId}>
            <ModalHeaderContainer>
                <DrawerTitleText className={styles.title} text={LOG_SERVICE} />
            </ModalHeaderContainer>

            <ModalBodyContainer>
                {showConfirmation ? (
                    confirmationPanel
                ) : (
                    <LogServiceFormFields
                        assetId={assetId}
                        form={form}
                        isCalibration={isCalibration}
                        isPartRequired={isPartRequired}
                        isPartVisible={isPartVisible}
                        isUnitVisible={isUnitVisible}
                        unitPartType={unitPartType}
                    />
                )}
            </ModalBodyContainer>

            {!showConfirmation && (
                <ModalFooterContainer>
                    <ErrorButton onClick={onRequestClose} testId={CANCEL_TEST_ID} text={CANCEL} />

                    <PrimaryButton
                        isDisabled={isSaveDisabled}
                        onClick={handleSubmit}
                        testId={SAVE_TEST_ID}
                        text={SAVE}
                    />
                </ModalFooterContainer>
            )}
        </VerticalContainer>
    );
};

export default LogServiceForm;
